import { LitElement } from "lit-element";
import { html } from "lit-html";
import { storeInstance } from "store/index.js";
import { getResource } from "lib/kblib";
import niceBytes from "../utils/niceBytes";

class KbFilepub extends LitElement {
  static get properties() {
    return {
      item: { type: Object },
      kbrid: { type: String },
      contentType: { type: String },
      filename: { type: String },
      extension: { type: String },
      pagenum: { type: Number },
      size: { type: String },
      src: { type: String },
      mimeTypes: { type: Array },
    };
  }

  constructor() {
    super();
    this.pagenum = 1;
  }

  connectedCallback() {
    super.connectedCallback();
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.item = this.state.item;
    this.fetchResource();
    storeInstance.dispatch("getParentPath", {
      extId: this.item.item.externalId,
    });
    this.mimeTypes = this.formatMimeTypes(this.state.mime_types);
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.item = this.state.item;
    this.mimeTypes = this.formatMimeTypes(this.state.mime_types);
  }

  formatMimeTypes(str) {
    return str.split(",").map((item) => new RegExp(item));
  }

  async fetchResource() {
    let [blob, filename] = await getResource(this.item.itemLang.resourceId);
    this.contentType = blob.type;
    this.size = niceBytes(blob.size);
    this.src = URL.createObjectURL(blob) || "";
    this.filename = filename;
    this.extension = this.getFileExtension(filename);
  }

  getFileExtension(filename) {
    return filename?.split(".")?.pop();
  }

  snackbarTemplate() {
    return html` <style>
        .icon-container {
          display: flex;
        }
        .snackbar-item {
          color: var(
            --kb-filepub-download-btn-background,
            var(--kb-primary-color-400),
            black
          );
        }
      </style>
      <div class="icon-container">
        <a class="snackbar-item" .href=${this.src} download=${this.filename}>
          <iron-icon icon="vaadin:download-alt"></iron-icon>
        </a>
      </div>`;
  }

  textFileTemplate() {
    return html` <style>
        .download-btn-container {
          display: flex;
          justify-content: flex-end;
        }
      </style>
      <div class="download-btn-container">
        <a .href=${this.src} download=${this.filename}>Download</a>
      </div>
      ${this.viewableDocumentTemplate()}`;
  }

  viewableDocumentTemplate() {
    let src = `/kb/jrest/getResource?kbrid=${this.state.item.itemLang.resourceId}&setToDownload=true#zoom=100&page=${this.pagenum}`;
    return html`
      <style>
        iframe {
          margin: 16px auto;
          display: block;
          background: #ebeaea;
          border: none;
          height: 74vh;
          width: 100%;
        }
        .snackbar-container {
          display: flex;
          justify-content: flex-end;
        }
      </style>
      <div class="snackbar-container">${this.snackbarTemplate()}</div>
      <div>
        <iframe src=${src} frameborder="1" scrolling="auto" width="1200">
        </iframe>
      </div>
    `;
  }

  downloadTemplate() {
    return html` <style>
        .download-btn {
          display: block;
          max-width: fit-content;
          padding: 0.5rem 1rem;
          background-color: var(
            --kb-filepub-download-btn-background,
            var(--kb-primary-color-400),
            black
          );
          color: var(
            --kb-filepub-download-btn-text,
            --kb-text-color-light,
            white
          );
          margin-top: 1rem;
          text-decoration: none;
        }
      </style>
      <div>
        <h1>
          ${this.item.itemLang.name}
          ${this.extension ? `(.${this.extension})` : null}
        </h1>
        ${this.item.itemLang?.description
          ? html`<p>${this.item.itemLang?.description}</p>`
          : null}
        <span>Size: ${this.size}</span>
        <a
          class="download-btn"
          .href=${this.src}
          download=${this.filename}
          >Download</a
        >
      </div>`;
  }

  isTextFile() {
    let textRule = /text\/*/;
    if (textRule.test(this.contentType)) {
      return true;
    }
    return false;
  }

  isIFrameRenderable() {
    if (this.mimeTypes.some((rule) => rule.test(this.contentType))) {
      return true;
    }
    return false;
  }

  chooseTemplate() {
    if (this.contentType !== undefined) {
      if (this.isIFrameRenderable()) {
        return this.viewableDocumentTemplate();
      }
      return this.downloadTemplate();
    }
  }

  render() {
    return html` <style>
        section {
          margin: 2rem;
        }

        /* a {
          display: block;
          max-width: fit-content;
          padding: 0.5rem 1rem;
          background-color: var(
            --kb-filepub-download-btn-background,
            var(--kb-primary-color-400),
            black
          );
          color: var(
            --kb-filepub-download-btn-text,
            --kb-text-color-light,
            white
          );
          margin-top: 1rem;
          text-decoration: none;
        } */
      </style>
      <section>${this.chooseTemplate()}</section>`;
  }
}

// let inclusionRules = [
//   /text\/*/,
//   /image\/*/,
//   /application\/pdf/,
//   /video\/mp4/,
//   /audio\/mp3/,
//   /application\/wasm/,
//   /application\/xml/,
//   /application\/json/,
// ];

customElements.define("kb-filepub", KbFilepub);
